import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'

function* fetchUsers() {
  try {

    const users = yield call(function () {
      return Api.get('/users');
    });
    yield put({type: 'FETCH_USERS.SUCCESS', users})
  } catch (error) {
    yield put({type: 'FETCH_USERS.FAILURE', error})
  }
}

export function* watchFetchUsers() {
  yield takeEvery('FETCH_USERS.REQUEST', fetchUsers)
}
